module.exports = __webpack_public_path__ + "static/media/m6pub.735d22ee.png";